import React from 'react';
import {
    DefaultButton,
    Dialog,
    DialogFooter,
    MessageBar,
    MessageBarType,
    PrimaryButton
} from '@fluentui/react';

interface IRemoveCustomerDialogProps {
    automationPrefix: 'admin' | 'creator';
    hidden: boolean;
    isRemoving: boolean;
    customerName?: string;
    hasError: boolean;
    onDismiss: () => void;
    onConfirm: () => void;
    className?: string;
}

const RemoveCustomerDialog: React.FC<IRemoveCustomerDialogProps> = ({
    automationPrefix,
    hidden,
    isRemoving,
    customerName,
    hasError,
    onDismiss,
    onConfirm,
    className
}) => (
    <Dialog
        data-testid={`${automationPrefix}-remove-customer-dialog`}
        hidden={hidden}
        onDismiss={isRemoving ? undefined : onDismiss}
        dialogContentProps={{
            title: 'Remove customer from ticket?',
            subText: `${customerName || 'This customer'} will be removed from this ticket. This can't be undone.`
        }}
        modalProps={{
            isBlocking: true,
            className
        }}>
        {hasError && (
            <MessageBar messageBarType={MessageBarType.error}>
                We couldn't remove this customer. Please try again.
            </MessageBar>
        )}
        <DialogFooter>
            <DefaultButton
                data-testid={`${automationPrefix}-remove-customer-cancel`}
                onClick={onDismiss}
                disabled={isRemoving}
                text="Cancel"
            />
            <PrimaryButton
                data-testid={`${automationPrefix}-remove-customer-confirm`}
                onClick={onConfirm}
                disabled={isRemoving}
                text="Remove"
            />
        </DialogFooter>
    </Dialog>
);

export default RemoveCustomerDialog;
